<template>
  <div>
    <!--<navTitle title="用户须知"></navTitle>-->
    <navTitle
      :title="
        $router.app._route.query.ti ? $router.app._route.query.ti : 'User notice'
      "
    ></navTitle>

    <div class="user-html v-html" v-html="html" style="margin-top: 1rem"></div>
  </div>
</template>

<script>
import navTitle from "@components/navTitle";
import { getUserMessgaes } from "@api/user";
export default {
  name: "userMessagaes",
  components: {
    navTitle
  },
  data: function() {
    return {
      html: "",
      id: "3"
    };
  },
  methods: {
    getList() {
      getUserMessgaes(this.id).then(res => {
        // console.log('getlist:',res)
        this.html = res.data.content;
      });
    }
  },
  mounted: function() {
    this.getList();
  }
};
</script>

<style scoped>
.user-html {
  padding: 0 0.3rem;
  font-size: 0.3rem;
  color: #333;
  line-height: 1.8;
  padding-top: 0.35rem;
  /*background: #FBFBFB;*/
}
</style>
